import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import projectStyles from '../project.module.less'
import idataCodingStyles from '../../common/global-styles/idatacoding.module.less'
import {BACKEND_API_URL } from '../../../constants/constants';
import {
  Table,
  message,
  Col,
  Row,
  Tabs,
  Button,
  Input,
  Popconfirm,
  Modal,
  ConfigProvider,
  Pagination,
  Tooltip,
  Select,
} from 'antd'
import {
  SyncOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  ClockCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import TooltipModal from '../../../component/modal/stop-task-modal/TooltipModal'
import BatchTooltipModal from '../../../component/modal/stop-task-modal/BatchTooltipModal'
import StatusCard from '../../../component/status-card/status-card'
import stuSubmitStyle from './project-student-submit.module.less'
import zhCN from 'antd/lib/locale/zh_CN'
import DateRangePicker from '../../../component/date-range-picker/DateRangePicker'
import { sendHttpPostRequest } from '../../../api/http-request'
import Cookies from 'js-cookie'

const { Search } = Input
const { Option } = Select
export interface Props {
  setSelectedTabKey: any
  college_id: any
  setSubmitId: any
}

const ProjectStuSubmit: React.FC<Props> = (props) => {
  const { college_id, setSubmitId } = props
  const location = useLocation()
  const projectId = location.search.includes('my_commit_record')
    ? location.search.split('project_id=')[1].split('/')[0]
    : location.search.split('project_id=')[1]
  const [commitRecordData, setCommitRecordData] = useState([] as any)
  const { setSelectedTabKey } = props
  const [statusCard, setStatusCard] = useState([
    {
      type: 'running',
      label: '运行中',
      num: 30,
    },
    {
      type: 'success',
      label: '成功',
      num: 30,
    },
    {
      type: 'failed',
      label: '失败',
      num: 30,
    },
    {
      type: 'stoped',
      label: '已停止',
      num: 30,
    },
    // {
    //   type: 'stopping',
    //   label: '正在停止',
    //   num: 30,
    // },
  ])

  const [seleOptions, setSeleOptions] = useState([] as any)
  const page = useRef(1)
  const pageSize = useRef(10)
  const query = useRef('')
  const order = useRef('')
  const orderBy = useRef('')
  const statusFilters = useRef([])
  const classroomIdFilters = useRef(0)
  const loopRequestTimer = useRef<any>()
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [selectRows, setSelectRows] = useState([] as any)
  const [open, setOpen] = useState(false)
  const [tooltipopen, setTooltipopen] = useState(false)
  const history = useHistory()
  // const [endDate, setEndDate] = useState('')
  // const [startDate, setStartDate] = useState('')
  const startDate = useRef('')
  const endDate = useRef('')
  const [total, setTotal] = useState(0)
  const [actionTask, setActionTask] = useState<any>()
  const getCommitRecordList = () => {
    let data = {
      query: query.current,
      classroom_id: classroomIdFilters.current,
      start_date: startDate.current,
      end_date: endDate.current,
      project_id: projectId,
      college_id: college_id,
      status: JSON.stringify(statusFilters.current),
      order: order.current,
      order_by: orderBy.current,
      page: page.current,
      page_size: pageSize.current,
    }
    sendHttpPostRequest('exercise/api/student_submit_list', data, (res) => {
      if (res.code == 0) {
        setCommitRecordData(res.data.list)
        setStatusCard(
          statusCard.map((c) =>
            c.type == 'running'
              ? { ...c, num: res.data.sum_count.execute_count }
              : c.type == 'success'
              ? { ...c, num: res.data.sum_count.success_count }
              : c.type == 'failed'
              ? { ...c, num: res.data.sum_count.fail_count }
              : { ...c, num: res.data.sum_count.interrupt_count }
          )
        )
        setTotal(res.data.page_info.total_count)
      } else {
        message.error(res.msg)
      }
    })
  }
  const getClassRoomList = () => {
    let data = {
      college_id: college_id,
      course_id: projectId,
    }
    sendHttpPostRequest(
      'classroom/api/teacher_query_classroom_list',
      data,
      (res) => {
        if (res.is_ok) {
          let list = res.query_list
          setSeleOptions([
            { label: '全部班级', value: 0 },
            ...list?.map((cls) => {
              return {
                label: cls.name,
                value: cls.id,
              }
            }),
          ])
        }
      }
    )
  }

  useEffect(() => {
    getCommitRecordList()
    // loopRequestTimer.current = setInterval(() => {
    //   getCommitRecordList()
    // }, 1000)

    getClassRoomList()
    return () => {
      // clearInterval(loopRequestTimer.current)
    }
  }, [])

  const onSelectChange = (newSelectedRowKeys: React.Key[], selectRows) => {
    setSelectedRowKeys(newSelectedRowKeys)
    setSelectRows([...selectRows])
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.status !== '运行中', // Column configuration not to be checked
    }),
  }

  const stopTask = (record) => {
    // console.log(record)
    setActionTask(record)
    setTooltipopen(true)
  }

  const hasSelected = selectedRowKeys.length > 0

  const renderStatus = (text: any, record: any, index: any) => {
    const cfgMap: Record<string, {bg: string; color: string; border: string; icon: React.ReactNode; label: string}> = {
      '运行中': { bg: '#eef2ff', color: '#4f46e5', border: '#c7d2fe', icon: <SyncOutlined spin={false} style={{marginRight: 5}} />, label: '运行中' },
      '成功':   { bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0', icon: <CheckCircleOutlined style={{marginRight: 5}} />, label: '成功' },
      '失败':   { bg: '#fef2f2', color: '#dc2626', border: '#fecaca', icon: <CloseCircleOutlined style={{marginRight: 5}} />, label: '失败' },
      '已停止': { bg: '#f9fafb', color: '#6b7280', border: '#e5e7eb', icon: <StopOutlined style={{marginRight: 5}} />, label: '已停止' },
    }
    const cfg = cfgMap[text]
    if (!cfg) return ''
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center',
        padding: '2px 10px', borderRadius: 999, fontSize: 12, fontWeight: 500,
        background: cfg.bg, color: cfg.color, border: `1px solid ${cfg.border}`,
        whiteSpace: 'nowrap',
      }}>
        {cfg.icon}{cfg.label}
      </span>
    )
  }

  const renderAction = (text: any, record: any, index: number) => (
    <Row align={'middle'} justify={'center'}>
      <Col style={{ gap: '10px' }}>
        <Tooltip placement="top" title={'查看'}>
          <div
            className="info-icon"
            onClick={() => {
              setSubmitId(record.id)
              setSelectedTabKey('student_commit_detail')
            }}
          >
            <i className="iconfont icon-chakan" style={{ fontSize: 17 }}></i>
          </div>
        </Tooltip>
      </Col>
      { record.status === '运行中' && <Col flex={'30px'}>
        
          <Tooltip placement="top" title={'停止'}>
            <div className="stoped-icon" onClick={stopTask.bind(this, record)}>
              <i className="iconfont icon-zhongzhi"></i>
            </div>
          </Tooltip>
         
      </Col>
    }
    </Row>
  )

  const gotoSubmitDetail = (record) => {
    setSelectedTabKey('my_commit_record')
    setSubmitId(record.id)
  }
  const CommitRecordCols: any = [
    {
      title: '提交ID',
      dataIndex: 'id',
      key: 'id',
      width: '100px',
      align: 'center',
      fixed: true,
      ellipsis:true
    },
    {
      title: '任务编号',
      dataIndex: 'task_number',
      key: 'task_number',
      width: '80px',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '任务名称',
      dataIndex: 'title',
      key: 'title',
      width: '200px',
      ellipsis: true,
      align: 'left',
      render: (text: any, record: any, index: any) => (
        <span
          onClick={gotoSubmitDetail.bind(this, record)}
          className={idataCodingStyles.link}
        >
          {text}
        </span>
      ),
    },
    {
      title: '学生',
      dataIndex: 'student_name',
      key: 'student_name',
      width: '150px',
      align: 'left',
      ellipsis: true,
      render: (t, r, i) => {
        return (
        <Row align="middle" justify="start" style={{ gap: '5px' }}>
            <Col>
            <img  src={ r.student_avatar?.startsWith("http") ? r.student_avatar : BACKEND_API_URL + r.student_avatar} alt="" style={{width:24,height:24,borderRadius:12,marginRight:6}}/>
            </Col>
            <Col>{r.student_name}</Col>
        </Row>
        )
    },
    },
    {
      title: '学号',
      dataIndex: 'student_number',
      key: 'student_number',
      width: '130px',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '班级',
      dataIndex: 'student_classroom',
      key: 'student_classroom',
      width: '200px',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '开始时间',
      dataIndex: 'req_time',
      key: 'req_time',
      width: '150px',
      align: 'center',
      sorter: true,
      ellipsis: true,
    },
    {
      title: '结束时间',
      dataIndex: 'res_time',
      key: 'res_time',
      width: '150px',
      align: 'center',
      sorter: true,
      ellipsis: true,
    },
    {
      title: '用时',
      dataIndex: 'time_range',
      key: 'time_range',
      width: '150px',
      align: 'center',
      sorter: true,
      ellipsis: true,
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: '100px',
      align: 'left',
      filters: [
        {
          text: '运行中',
          value: '1',
        },
        {
          text: '成功',
          value: '2',
        },
        {
          text: '失败',
          value: '3',
        },
        {
          text: '已停止',
          value: '4',
        },
        // {
        //   text: '正在停止',
        //   value: '正在停止',
        // },
      ],
      render: renderStatus,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: '100px',
      align: 'center',
      fixed: 'right',
      render: renderAction,
    },
  ]

  const searchByTaskNameAndId = (value: any) => {
    getCommitRecordList()
  }

  const selectChange = (value: any) => {
    page.current = 1
    classroomIdFilters.current = value.value
    getCommitRecordList()
  }

  const onPageChange = (newPage: number, newPageSize: number) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    getCommitRecordList()
  }

  const datePanelChange = (value, mode) => {
    console.log(value, mode)
  }

  const onBatchStopTaskOk = () => {
    let interruptList = selectRows?.map((sele) => {
      return {
        exercise_submit_id: sele.id,
        user_id: sele.user_id,
        exercise_id: sele.exercise_id,
      }
    })
    let data = {
      source: 2, //1 我的   2 学生
      // exercise_submit_id: actionTask?.id,
      // exercise_id: actionTask?.exercise_id,
      interrupt_list: JSON.stringify(interruptList), // 批量
    }
    sendHttpPostRequest(
      'exercise/api/running_exercise_interrupt',
      data,
      (res) => {
        if (res.code == 0) {
          getCommitRecordList()
          message.success('停止成功~')
        } else {
          message.error(res.msg)
        }
      }
    )
    setOpen(false)
  }

  const onStopTaskOk = () => {
    let interruptList = [
      {
        exercise_submit_id: actionTask?.id,
        user_id: actionTask?.user_id,
        exercise_id: actionTask?.exercise_id,
      },
    ]
    let data = {
      source: 2, //1 我的   2 学生
      // exercise_submit_id: actionTask?.id,
      // exercise_id: actionTask?.exercise_id,
      interrupt_list: JSON.stringify(interruptList), // 批量
    }
    sendHttpPostRequest(
      'exercise/api/running_exercise_interrupt',
      data,
      (res) => {
        if (res.code == 0) {
          getCommitRecordList()
          message.success('停止成功~')
        } else {
          message.error(res.msg)
        }
      }
    )
    setTooltipopen(false)
  }

  const onTableChange: any = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: []; action: any }
  ) => {
    if (sorter.order) {
      //如果选择了排序列
      order.current = sorter.order
      orderBy.current = sorter.field
    } else {
      order.current = ''
      orderBy.current = ''
    }
    if (filters.status) {
      //如果选择了过滤列
      statusFilters.current = filters.status
    } else {
      statusFilters.current = []
    }

    page.current = 1
    getCommitRecordList()
  }

  return (
    <div style={{minWidth: 800}}>
      {/* 状态统计卡片 */}
      <div style={{display: 'flex', gap: 12, marginBottom: 16}}>
        {statusCard.map((card) => {
          const cfgMap = {
            running: { bg: '#eef2ff', color: '#4f46e5', border: '#c7d2fe', icon: <SyncOutlined /> },
            success: { bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0', icon: <CheckCircleOutlined /> },
            failed:  { bg: '#fef2f2', color: '#dc2626', border: '#fecaca', icon: <CloseCircleOutlined /> },
            stoped:  { bg: '#f9fafb', color: '#6b7280', border: '#e5e7eb', icon: <StopOutlined /> },
          }
          const cfg = cfgMap[card.type] || cfgMap.stoped
          return (
            <div key={card.type} style={{
              flex: 1, display: 'flex', alignItems: 'center', gap: 12,
              padding: '12px 16px', borderRadius: 10,
              background: cfg.bg, border: `1px solid ${cfg.border}`,
            }}>
              <span style={{fontSize: 22, color: cfg.color}}>{cfg.icon}</span>
              <div>
                <div style={{fontSize: 22, fontWeight: 700, color: cfg.color, lineHeight: 1.2}}>{card.num}</div>
                <div style={{fontSize: 12, color: '#6b7280', marginTop: 2}}>{card.label}</div>
              </div>
            </div>
          )
        })}
      </div>

      {/* 工具栏 */}
      <Row wrap={false} align="middle" className={stuSubmitStyle.toolbar} style={{marginBottom: 14, gap: 8}} gutter={[8, 0]}>
        <Col flex="320px">
          <Input
            onPressEnter={()=>{page.current = 1; getCommitRecordList()}}
            onChange={()=>{page.current = 1; getCommitRecordList()}}
            size="middle"
            placeholder="请输入任务名称/编号..."
            prefix={<SearchOutlined style={{color: '#9ca3af'}} />}
            style={{borderRadius: 8, height: 36}}
          />
        </Col>
        <Col flex="160px">
          <Select
            style={{width: '100%', height: 36}}
            getPopupContainer={(trigger) => trigger.parentNode}
            labelInValue
            defaultValue={'全部班级'}
            onChange={selectChange}
          >
            {seleOptions.map((opt) => (
              <Option key={opt.value} value={opt.value}>{opt.label}</Option>
            ))}
          </Select>
        </Col>
        <Col flex="auto">
          <DateRangePicker
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={(date, dateString) => {
              startDate.current = dateString.split('/').join('-')
              page.current = 1
              getCommitRecordList()
            }}
            onEndDateChange={(date, dateString) => {
              endDate.current = dateString.split('/').join('-')
              page.current = 1
              getCommitRecordList()
            }}
            mode="user"
          />
        </Col>
        <Col flex="100px" style={{textAlign: 'right'}}>
          <Button
            type="primary"
            disabled={selectedRowKeys.length === 0}
            onClick={() => setOpen(true)}
            style={{borderRadius: 8, height: 36, fontSize: 13, ...(selectedRowKeys.length > 0 ? {backgroundColor: '#4f46e5', borderColor: '#4f46e5'} : {})}}
          >
            批量停止
          </Button>
        </Col>
      </Row>

      <div className={idataCodingStyles.tableWrapper} style={{minHeight: 380}}>
        <ConfigProvider locale={zhCN}>
          <Table
            className={projectStyles.studentTable}
            dataSource={commitRecordData}
            columns={CommitRecordCols}
            rowKey={(record, index) => index!.toString()}
            rowSelection={rowSelection}
            scroll={{ x: 600 }}
            size="small"
            pagination={false}
            onChange={onTableChange}
          />
        </ConfigProvider>
      </div>
      <div
        className={idataCodingStyles.dfPagination}
        style={{ textAlign: 'center', marginTop: 20 }}
      >
        <ConfigProvider locale={zhCN}>
          <Pagination
            pageSize={pageSize.current}
            total={total}
            current={page.current}
            onChange={onPageChange}
            hideOnSinglePage
          />
        </ConfigProvider>
      </div>
      <BatchTooltipModal
        open={open}
        setOpen={setOpen}
        taskcount={selectedRowKeys.length}
        mode={'user'}
        onOk={onBatchStopTaskOk}
        // content={<p>确定要停止选中的{selectedRowKeys.length}个任务吗？</p>}
      />
      <TooltipModal
        tooltipopen={tooltipopen}
        setTooltipopen={setTooltipopen}
        mode={'user'}
        onOk={onStopTaskOk}
        content={<p>此任务正在运行中，确定要停止任务吗？</p>}
      />
    </div>
  )
}

export default ProjectStuSubmit
